import http from "../http";
import {useQuery} from "vue-query";
import { computed, reactive } from 'vue';

export function useBrand() {
  const current = params => http.get('/api/brands/current', {params});
  const getBrands = (params) => useQuery(reactive(['userBrands', {params}]), ({ queryKey }) => http.get('/api/user/brands', {params: queryKey[1].params}));
  const updateCurrent = params => http.post('/api/brands/current', params);
  const getIntegrations = async () => http.get(`/api/brands/integrations`);
  const getDashboardMessages = (options) => useQuery(['dashboardMessages'],() => http.get(`/api/brands/dashboard-messages`), options);
  // const getDashboardMessages = async () => http.get(`/api/brands/dashboard-messages`);
  const invite = async (email) => http.post('/api/brands/invite', {email});
  const users = async (params) => http.get('/api/brands/users', {params})
  const deleteUser = async (id) => http.delete(`/api/brands/users/${id}`)
  const getMessages = async () => http.get(`/api/brands/messages`);
  const createMessage = async (to, params) => http.post(`/api/brands/messages/${to}`, params);
  const registerNewBrand = async (params) => http.post(`/api/register/brand/info`, params);
  const addNewCard = async (params) => http.post(`/api/register/brand/payment`, params);

  return {
    current,
    getBrands,
    getDashboardMessages,
    updateCurrent,
    getIntegrations,
    invite,
    users,
    deleteUser,
    getMessages,
    createMessage,
    registerNewBrand,
    addNewCard,
  }
}
